


import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, getDocs, addDoc, doc, updateDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";



const firebaseConfig = {
  apiKey: "AIzaSyCMgBMTODZwpH0O_-8vg9-kOznWeeUBTUs",
  authDomain: "eye-contact-50d68.firebaseapp.com",
  projectId: "eye-contact-50d68",
  storageBucket: "eye-contact-50d68.firebasestorage.app",
  messagingSenderId: "882850847000",
  appId: "1:882850847000:web:1315f399d52f5ca72ee66d"
};



const app = initializeApp(firebaseConfig);

const db = getFirestore(app);  // Firestore initialization
const storage = getStorage(app);  // Firebase Storage initialization

export const auth = getAuth(app);
export { db, storage, getDocs, collection, addDoc, doc, updateDoc  };  // Correct export